import { formatBirthDateInput } from '../../lib/validate-date'

export const DATE_MASK = '00.00.0000'
export const PASSPORT_NUMBER_MASK = '00 00 000000'
export const INN_MASK = '000000000000'
export const PHONE_NUMBER_MASK = '+7 (000) 000-00-00'
export const NUMBER_MASK = '000000'
export const UNIT_CODE_MASK = '000-000'

export type TMaskPreset = 'date' | 'inn' | 'number' | 'passportNumber' | 'phoneNumber' | 'unitCode'

type TMaskPresetConfig = {
    formatValue: (value: string) => string
    mask: string
}

export const MASK_PRESETS: Record<TMaskPreset, TMaskPresetConfig> = {
    date: {
        formatValue: formatBirthDateInput,
        mask: DATE_MASK,
    },
    inn: {
        formatValue: formatInn,
        mask: INN_MASK,
    },
    number: {
        formatValue: formatNumber,
        mask: NUMBER_MASK,
    },
    passportNumber: {
        formatValue: formatPassportNumber,
        mask: PASSPORT_NUMBER_MASK,
    },
    phoneNumber: {
        formatValue: formatPhoneNumber,
        mask: PHONE_NUMBER_MASK,
    },
    unitCode: {
        formatValue: formatUnitCode,
        mask: UNIT_CODE_MASK,
    },
}

export const getMaskSuffix = (mask: string, value: string): string => mask.slice(value.length)

export const getMaskedDisplayValue = (preset: TMaskPreset, value: string): string =>
    preset === 'phoneNumber' ? formatPhoneDisplay(value) : value

export function formatPhoneNumber(value: string): string {
    return value.replaceAll(/\D/g, '').slice(0, 11)
}

export function formatUnitCode(value: string): string {
    const digits = value.replaceAll(/\D/g, '').slice(0, 6)

    if (digits.length <= 3) {
        return `${digits.slice(0, 3)}`
    }

    return `${digits.slice(0, 3)}-${digits.slice(3)}`
}

export function formatPhoneDisplay(value: string): string {
    const digits = value.replaceAll(/\D/g, '')

    if (!digits) {
        return ''
    }

    let result = '+'
    let index = 0

    result += digits[index]
    index += 1

    if (index >= digits.length) {
        return result
    }

    result += ' ('

    while (index < digits.length && index < 4) {
        result += digits[index]
        index += 1
    }

    if (index >= digits.length) {
        return result
    }

    result += ') '

    while (index < digits.length && index < 7) {
        result += digits[index]
        index += 1
    }

    if (index >= digits.length) {
        return result
    }

    result += '-'

    while (index < digits.length && index < 9) {
        result += digits[index]
        index += 1
    }

    if (index >= digits.length) {
        return result
    }

    result += '-'

    while (index < digits.length && index < 11) {
        result += digits[index]
        index += 1
    }

    return result
}

export function formatPassportNumber(value: string): string {
    const digits = value.replaceAll(/\D/g, '').slice(0, 10)

    if (digits.length <= 2) {
        return digits
    }

    if (digits.length <= 4) {
        return `${digits.slice(0, 2)} ${digits.slice(2)}`
    }

    return `${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4)}`
}

export function formatInn(value: string): string {
    return value.replaceAll(/\D/g, '').slice(0, 12)
}

export function formatNumber(value: string): string {
    return value.replaceAll(/\D/g, '').slice(0, 6)
}
